/** Created by azhou on 2018/8/17.*/
<template>
  <!--弹出手机号验证框-->
  <div class="verify-phone">
    <div class="verify-phone-content">
        <i class="el-icon-close icon"  @click="$emit('switch')"></i>
        <div class="code">安全验证</div>
        <div class="phone">
            <div class="titlename">手机号: </div>
            <div class="number">{{number| formatPhone}}</div>
        </div>
        <div class="input">
            <div class="titlename">验证码: </div>
            <input v-model="sms_code" placeholder="请输入验证码" class="code-input" type="number"/>
            <label class="send-code"
             :class="[getCodeFlag ? 'disabled-code-2' : '']"
             >
                <span v-show="getCodeFlag" class="disabled-code">{{timeCount}}重新发送</span>
                <span  v-show="!getCodeFlag" @click="getCode">获取验证码</span>
            </label>
        </div>
        <div class="name" @click="getConfirm">确认</div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  export default {
    name: 'number',
    data () {
        return {
            sms_code: '',
            timeCount: 60,     //倒计时
            getCodeFlag: false, //发送验证码按钮状态
            timer: null,
            mobileverify:[],
        }
    },
    destroyed () {
      clearInterval(this._timer)
    },
    created(){
          const mobileverify =JSON.parse(sessionStorage.getItem('mobileverify'))||[];
          if(mobileverify.length>0){
            let tiem=mobileverify.filter(todo=>todo.mobile==this.number)[0];
            let nowTime=new Date().getTime();
            if(tiem&&nowTime-tiem.tiem<60000){
              let num =60-(nowTime-tiem.tiem)/1000;
              this.timeCount=num.toFixed(0);
              this.getCodeFlag=true;
              this._timer = setInterval(() => {
              this.timeCount--
                if (this.timeCount <= 0) {
                  clearInterval(this._timer)
                  this.getCodeFlag = false
                }
              }, 1000)
            }
        }
        this.mobileverify=mobileverify;
    },
    props:{
        //路径
        url:{
            type:String,
        },
        number:{
            type: String,
        }
    },
    methods: { 
        //获取手机号验证码
         getCode:_.debounce (async function () {
            let resData = await this.$axios.post(this.url,{})
            if (resData.code === '00000') {
                //保存已发送验证码手机号刷新再次发送
                const index = this.mobileverify.findIndex(user => user.mobile === this.number);
                if (index !== -1) {
                    this.mobileverify[index]={mobile:this.number,tiem:new Date().getTime()};
                }else{
                    this.mobileverify.push({mobile:this.number,tiem:new Date().getTime()});
                }
                sessionStorage.setItem('mobileverify',JSON.stringify(this.mobileverify));
                this.getCodeFlag = true
                this.timeCount = 60
                this._timer = setInterval(() => {
                    this.timeCount--
                    if (this.timeCount <= 0) {
                    clearInterval(this._timer)
                    this.getCodeFlag = false
                    }
                }, 1000)
            }
        },300),
        getConfirm(){
            if (this.sms_code) {
                this.$emit('submitOrder',this.sms_code)
            } else this._alert('请输入验证码',null,'error');
            
        },
      },
  }
</script>

<style lang="scss" scoped>
    .verify-phone{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9;
        background: rgba(0, 0, 0, .4);
        width: 100%;
        height: 100vh;
    }
    .verify-phone-content{
        width: 400px;
        padding: 15px;
        height: 240px;
        background-color: #fff;
        margin: 0 auto;
        margin-top: 18%;
        border-radius: 6px;
    }
    .icon{
        float: right;
        padding: 4px 3px 3px 4px;
        font-size: 16px;
        background-color: #999;
        color: #fff;
        border-radius: 50px;
        cursor: pointer;
    }
    .code{
        font-size: 20px;
        letter-spacing: 1px;
        font-weight: bold;
        width: 100%;
        overflow: hidden;
        color: #333;
        margin-bottom: 20px;
        text-align: center;
    }
    .phone{
        width: 90%;
        margin: 0 auto;
        display: flex;
        justify-content: left;
        margin-top: 12px;
    }
    .number{
        line-height: 40px;
    }
    .titlename{
        line-height: 40px;
        background-color: #fff;
        height: 40px;
        width: 100px;
    }
    .input{
        width: 90%;
        margin: 0 auto;
        display: flex;
        border-radius: 4px;
        overflow: hidden;
        margin-top: 20px;
    }
    .code-input{
        background-color: #f2f2f2;
        border: none;
        outline: none;
        width: 130px;
        text-align: center;
        border-radius: 4px 0 0 4px;
    }
    .send-code{
        text-align: center;
        width: 25%;
        cursor: pointer;
        line-height: 40px;
        background-color: var(--smtc-color-primary);
        color: #fff;
        border-radius: 0 4px 4px 0;
    }
    .disabled-code{
        color: #999;
    }
    .name{
        width: 100px;
        height: 40px;
        line-height: 40px;
        margin: 0 auto;
        margin-top: 20px;
        border-radius: 5px;
        color: #fff;
        background-color: var(--smtc-color-primary);
        cursor: pointer;
        text-align: center;
    }
    .disabled-code-2{
        background-color: #f2f2f2;
    }
    .bais{
        background-color: #fff;
    }
</style>
